import React, { useEffect, useState } from "react";
import { Button, Row, Col, Card, Table, NavLink } from "react-bootstrap";
import { LAYOUT } from "constants.js";
import CsLineIcons from "cs-line-icons/CsLineIcons";
import Clamp from "components/clamp";
import _ from "lodash";
import PropTypes from "prop-types";

const Academics = ({ user, tabHandler, ...props }) => {
  const { academicRecord, studentProfile, academicBatch } = user;

  const std10 = _.find(academicRecord || [], { gradlevelId: "std10" });
  const std12 = _.find(academicRecord || [], { gradlevelId: "std12" });
  const dip = _.find(academicRecord || [], { gradlevelId: "dip" });
  const ug = _.find(academicRecord || [], function (item) {
    return item.gradlevelId === "ug";
  });
  /*
  const btech = _.find(academicRecord || [], function (item) {
    return item.gradlevelId === "ug" && (item.course === "btech" || item.course === "be");
  });
  const enrollemntBatch = studentProfile.enrollmentBatchId;
  */
  let ugTitleLine = ug.courseInfo.name;
  if(ug.branch!=="" && ug.branch!=="-1"){
    ugTitleLine = (_.has(ug,"branchInfo") && !_.isEmpty(ug.branchInfo))?ugTitleLine + " - " + ug.branchInfo.name:ugTitleLine;
  }else{
    ugTitleLine = (ug.branchIfOther!=="" && ug.branchIfOther!=="-1")?ugTitleLine + " - " + ug.branchIfOther:ugTitleLine;
  }
  
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const ugOngoing = (currentYear < ug.qualifyingYear || (currentYear===ug.qualifyingYear && currentMonth<7))?true:false;
  
  return (
    <div>
      {ug && !_.isEmpty(ug) && (
        <Row className="g-0">
          <Col xs="auto" className="sw-7 d-flex flex-column justify-content-center align-items-center position-relative me-3">
            <div className="w-100 d-flex" />            
              <div className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center mt-0">
                <div className={(ugOngoing)?"outer-circle":""}>
                  <div className={(ugOngoing)?"inner-circle":""}>
                  <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
                    <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                      <div>{ug.qualifyingYear}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>            
            <div className="w-100 d-flex h-100 justify-content-center position-relative">
              <div className="line-w-1 bg-separator h-100 position-absolute" />
            </div>
          </Col>
          <Col className="mb-4">
            <div className="d-flex flex-column justify-content-start mt-2">
              <NavLink className="m-0 p-0" onClick={() => tabHandler("Academics")}>
                {ugTitleLine}
              </NavLink>
              <div className="text-alternate">
                {ug.joiningYear} - {ug.qualifyingYear}
                {ug.qualifyingMarks && ug.qualifyingMarks !== "" ? ` | Marks Obtained : ${ug.qualifyingMarks}%` : ""}
              </div>
              <div className="text-muted mt-1">
                {ug.qualifyingInstitution}, {ug.qualifyingInstitutionCity}
              </div>
              <div className="text-muted mt-1">Affiliated to: {ug.affiliatingInstitution}</div>
            </div>
          </Col>
        </Row>
      )}
      {dip && !_.isEmpty(dip) && (
        <Row className="g-0">
          <Col xs="auto" className="sw-7 d-flex flex-column justify-content-center align-items-center position-relative me-3">
            <div className="w-100 d-flex" />
            <div className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center mt-0">
              <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
                <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                  <div>{dip.qualifyingYear}</div>
                </div>
              </div>
            </div>
            <div className="w-100 d-flex h-100 justify-content-center position-relative">
              <div className="line-w-1 bg-separator h-100 position-absolute" />
            </div>
          </Col>
          <Col className="mb-4">
            <div className="d-flex flex-column justify-content-start mt-2">
              <NavLink className="m-0 p-0" onClick={() => tabHandler("Academics")}>
                {dip.course}
              </NavLink>
              <div className="text-alternate">
                {dip.joiningYear} - {dip.qualifyingYear}
                {dip.qualifyingMarks && dip.qualifyingMarks !== "" ? ` | Marks Obtained : ${dip.qualifyingMarks}%` : ""}
              </div>
              <div className="text-muted mt-1">
                {dip.qualifyingInstitution}, {dip.qualifyingInstitutionCity}
              </div>
              <div className="text-muted mt-1">Affiliated to: {dip.affiliatingInstitution}</div>
            </div>
          </Col>
        </Row>
      )}
      {std12 && !_.isEmpty(std12) && (
        <Row className="g-0">
          <Col xs="auto" className="sw-7 d-flex flex-column justify-content-center align-items-center position-relative me-3">
            <div className="w-100 d-flex" />
            <div className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center mt-0">
              <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
                <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                  <div>{std12.qualifyingYear}</div>
                </div>
              </div>
            </div>
            <div className="w-100 d-flex h-100 justify-content-center position-relative">
              <div className="line-w-1 bg-separator h-100 position-absolute" />
            </div>
          </Col>
          <Col className="mb-4">
            <div className="d-flex flex-column justify-content-start mt-3">
              <div className="text-body">
                12<sup>th</sup>
                <span className="text-separator ps-1 pe-1">|</span>
                {std12.qualifyingInstitution.replace("|", ", ")}
              </div>
              <div className="text-alternate">
                Year of Graduation : {std12.qualifyingYear} | Marks Obtained : {std12.qualifyingMarks}%{" "}
              </div>
              <div className="text-muted mt-1">Affiliated to: {std12.affiliatingInstitution && std12.affiliatingInstitution !== "" ? std12.affiliatingInstitution : "--"}</div>
            </div>
          </Col>
        </Row>
      )}
      {std10 && !_.isEmpty(std10) && (
        <Row className="g-0">
          <Col xs="auto" className="sw-7 d-flex flex-column justify-content-center align-items-center position-relative me-3">
            <div className="w-100 d-flex" />
            <div className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center">
              <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
                <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                  <div>{std10.qualifyingYear}</div>
                </div>
              </div>
            </div>
            <div className="w-100 d-flex h-100" />
          </Col>
          <Col className="mb-4">
            <div className="d-flex flex-column justify-content-start mt-3">
              <div className="text-body">
                10<sup>th</sup>
                <span className="text-separator ps-1 pe-1">|</span>
                {std10.qualifyingInstitution.replace("|", ", ")}
              </div>
              <div className="text-alternate">
                Year of Graduation : {std10.qualifyingYear} | Marks Obtained : {std10.qualifyingMarks}%{" "}
              </div>
              <div className="text-muted mt-1">Affiliated to: {std10.affiliatingInstitution && std10.affiliatingInstitution !== "" ? std10.affiliatingInstitution : "--"}</div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Academics;
Academics.propTypes = {
  user: PropTypes.object.isRequired,
};
